import { render, staticRenderFns } from "./StatusTextFormatter.vue?vue&type=template&id=3999c673&"
import script from "./StatusTextFormatter.vue?vue&type=script&lang=ts&"
export * from "./StatusTextFormatter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports